export default "__VITE_ASSET__8416fd43__"